import React from "react";
import { ToastContainer } from "react-toastify";
import { Route } from "react-router-dom";
import LoggedIn from "./Containers/LoggedIn";
import LoggedOut from "./Containers/LoggedOut";
import { isUser } from "./utils/helpers";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

class App extends React.Component {
  render() {
    return (
      <div>
        <ToastContainer
          autoClose={3500}
          newestOnTop
          hideProgressBar={false}
          theme="colored"
          closeButton
          closeOnClick={false}
          pauseOnFocusLoss={false}
          draggable={false}
        />
        {isUser() ? (
          <Route path="/" component={LoggedIn} />
        ) : (
          <Route path="/" component={LoggedOut} />
        )}
      </div>
    );
  }
}

export default App;
